import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';

export const MAP_ON_OPTIONS = ['DAILY', 'WEEKLY', 'MONTHLY'] as const;
export type MapOn = (typeof MAP_ON_OPTIONS)[number];

export const MAP_ON_LABELS: Record<MapOn, string> = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
};

export const DEFAULT_MAP_ON: MapOn = 'DAILY';

export const MO_TRAVEL_LIST_PAGE_SIZE = 50;

export const ACTIVITY_STATUS = ['ACTIVE', 'IDLE', 'SUBMITTED', 'NO_LOCATION'] as const;
export type ActivityStatus = (typeof ACTIVITY_STATUS)[number];

export const MO_TRAVEL_SORT_COLUMNS = ['lastActivity'] as const;
export type MoTravelSortColumn = (typeof MO_TRAVEL_SORT_COLUMNS)[number];

export const ACTIVITY_STATUS_LABELS: Record<ActivityStatus, string> = {
  ACTIVE: 'Active now',
  IDLE: 'Idle',
  SUBMITTED: 'Submitted',
  NO_LOCATION: 'No GPS',
};

export const DCR_APPROVAL_STATUS = ['APPROVED', 'RECOMMENDED', 'PENDING', 'REJECTED'] as const;
export type DcrApprovalStatus = (typeof DCR_APPROVAL_STATUS)[number];

export const DCR_APPROVAL_STATUS_LABELS: Record<DcrApprovalStatus, string> = {
  APPROVED: 'Approved',
  RECOMMENDED: 'Recommended',
  PENDING: 'Pending',
  REJECTED: 'Rejected',
};

export const DCR_APPROVAL_STATUS_TONE: Record<DcrApprovalStatus, StatusColorTone> = {
  APPROVED: APPROVAL_STATUS_TONE.approved,
  RECOMMENDED: APPROVAL_STATUS_TONE.recommended,
  PENDING: APPROVAL_STATUS_TONE.pending,
  REJECTED: APPROVAL_STATUS_TONE.rejected,
};

export const MAP_FLY_DURATION_SECONDS = 0.6;

export const MAP_MOVING_CLASS = 'map-moving';

export const PAUSED_WHILE_MAP_MOVING_CLASS = 'in-[.map-moving]:paused!';

export const ROUTE_VIEW_PADDING_PX = 72;

export const WAYPOINT_MARKER_SIZE_PX = 20;

export const HIGHLIGHTED_MARKER_GROWTH_PX = 6;

export const HIGHLIGHT_RING_CLASS = 'ring-4 ring-highlight/70';

export const LATEST_START_BADGE_CLASS =
  'shrink-0 rounded bg-route-start px-1 py-px text-4xs leading-3 font-semibold text-white';

export const UNLOCATED_STOP_COLOR = 'var(--muted-foreground)';

export const DAY_LIST_SEPARATOR = ',';

export const START_ICON_VIEWBOX = '0 0 24 24';

export const START_ICON_PATH =
  'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7';

export const END_ICON_VIEWBOX = '0 0 24 24';

export const END_ICON_PATH =
  'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z';
